import React from 'react'
import styled from 'styled-components'

const Container = styled.header`
  position: fixed;
  z-index: 9999;
  top: 0;
  left: 0;
  width: 100%;
  display: flex;
  align-items: center;
  padding: 1.5em;
  color: #fff;
  background: #4a4b4c;
`

const Logo = styled.div`
  font-weight: 600;
`

const Nav = styled.nav`
  display: flex;
  margin-left: auto;
`

const NavItem = styled.div`
  padding: 0 0.5rem;
  font-weight: 600;
  font-size: 0.875rem;
  cursor: pointer;

  :hover {
    color: #2ee277;
  }
`

const handleMailTo = (subject, body) => {
  window.location.href = `mailto:matt@mattislearning.com?subject=${subject}&body=${body}`
}

const Header = props => {
  return (
    <Container>
      <Logo>To: Wake From:</Logo>
      <Nav>
        <NavItem onClick={() => handleMailTo('Request To: Wake From: Book')}>
          Request Book
        </NavItem>
        <NavItem
          onClick={() =>
            handleMailTo(
              'Request To: Wake From: Book',
              'I would like to add this location:'
            )
          }>
          Add Book
        </NavItem>
        <NavItem onClick={props.openModal}>About</NavItem>
      </Nav>
    </Container>
  )
}

export default Header



// WEBPACK FOOTER //
// ./src/Header.js